import { CspSuggestion, CspSuggestionParams } from './types';
import { globalGetService } from '@/utils/globalApiServices';

export const getCspSuggestions = async (queries: CspSuggestionParams = {}) => {
  const response = await globalGetService('dca/csp/suggestions', queries);
  return (response?.ok ? response.data : []) as CspSuggestion[];
};
